import Vue from 'vue'
import { RemoteInstance } from 'directus-sdk-javascript'
import _ from 'lodash'

const directusClient = new RemoteInstance({
  url: process.env.VUE_APP_BACKEND_URL,
  version: process.env.VUE_APP_BACKEND_VERSION
})

const articles = {
  namespaced: true,
  state: {
    articles: [],
    covers: []
  },
  getters: {
    article: state => slug => _.find(state.articles, a => a.slug === slug),
    list: state => state.articles,
    cover: state => id => state.covers[id]
  },
  mutations: {
    updateArticles (state, articles) {
      Vue.set(state, 'articles', articles)
    },
    setCover (state, { id, file }) {
      Vue.set(state.covers, id, file)
    }
  },
  actions: {
    async getArticles ({ commit }) {
      const { data } = await directusClient.getItems('articles')
      commit('updateArticles', data)
    },
    async getCover ({ commit }, id) {
      const { data } = await directusClient.getFile(id)
      commit('setCover', { id, file: data.url })
    }
  }
}

export default articles
